import { action } from 'satcheljs';
/**
 * Called when there is a change in the event duration dropdown
 */
var selectEventDuration = action('selectEventDuration', function (defaultEventDuration) { return ({
    defaultEventDuration: defaultEventDuration,
}); });
export default selectEventDuration;
//# sourceMappingURL=selectEventDuration.js.map